import type { AdminUserSession } from '@ferty9/types';

const SESSION_KEY = 'ferty9_user';
const DOCTOR_KPI_SESSION_CACHE_KEY = 'ferty9_doctor_kpi_report_cache_v1';
const LOGOUT_PENDING_KEY = 'ferty9_admin_logout_pending_at';
const LOGOUT_PENDING_MS = 10_000;
const SESSION_VERIFIED_KEY = 'ferty9_admin_session_verified_at';
const SESSION_VERIFIED_MS = 15_000;

export function getAdminSession(): AdminUserSession | null {
  if (typeof window === 'undefined') return null;
  const value = window.sessionStorage.getItem(SESSION_KEY);
  if (!value) return null;
  return JSON.parse(value) as AdminUserSession;
}

export function setAdminSession(session: AdminUserSession): void {
  window.sessionStorage.removeItem(LOGOUT_PENDING_KEY);
  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
  window.sessionStorage.setItem(SESSION_VERIFIED_KEY, String(Date.now()));
}

export function isAdminSessionFresh(): boolean {
  const verifiedAt = Number(window.sessionStorage.getItem(SESSION_VERIFIED_KEY));
  return Number.isFinite(verifiedAt) && Date.now() - verifiedAt <= SESSION_VERIFIED_MS;
}

export function markAdminLogoutPending(): void {
  window.sessionStorage.setItem(LOGOUT_PENDING_KEY, String(Date.now()));
}

export function isAdminLogoutPending(): boolean {
  const startedAt = Number(window.sessionStorage.getItem(LOGOUT_PENDING_KEY));
  if (!Number.isFinite(startedAt) || Date.now() - startedAt > LOGOUT_PENDING_MS) {
    window.sessionStorage.removeItem(LOGOUT_PENDING_KEY);
    return false;
  }
  return true;
}

export function clearAdminSession(): void {
  window.sessionStorage.removeItem(SESSION_KEY);
  window.sessionStorage.removeItem(SESSION_VERIFIED_KEY);
  window.sessionStorage.removeItem(DOCTOR_KPI_SESSION_CACHE_KEY);
  window.localStorage.removeItem(SESSION_KEY);
}
